//react-components
import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import _ from "lodash";

//Components
import LoadingModal from "../CustomUIComponents/LoadingModal/LoadingModal";
import UserList from "./UserList";

//Actions
import {
  saveUserDetailsAction,
  clearUserDetailsAction,
  getUserRolesAction,
  getUsersBySearchFilterAction,
} from "./UserListAction";
import { getProfilePhotoAction } from "../AddOrUpdateUser/AddOrUpdateUserAction";
import { setSearchFilterAction } from "../redux/Action";

//Constants
import {
  API_RESPONSE_STATUS_CODES,
  SEARCH_FILTER_PAGES,
  USER_LIST_FILTER,
} from "../Utils/Constants";
import { APPLICATION_CONFIGURATIONS } from "../Utils/ApplicationConfigurations";

//Assets
import ProfileImage from "../Assets/images/ic_header_default_user.svg";

//Styles
import "./UserList.scss";

//Strings
import { Strings } from "../Translations/i18n";

class UserListContainer extends Component {
  constructor(props) {
    super(props);
    //Columns are created with specific names and key
    this._columns = [
      {
        key: "image",
        name: Strings("image"),
        cellClass: "myCustomCellClass",
      },
      {
        key: "user",
        name: Strings("user"),
      },
      {
        key: "firstName",
        name: Strings("firstName"),
      },
      {
        key: "lastName",
        name: Strings("lastName"),
      },
      {
        key: "role",
        name: Strings("role"),
        cellClass: "noPadding",
      },
    ];
    //Initially no rows are presents
    this.state = {
      rows: [],
      usersProfilePic: [],
      usersResponseData: null,
      showLoadingModal: false,
      searchFilter: {},
    };
    this.isUserClick = false;
  }
  componentDidMount() {
    this.handleOnClickSearchFilter({
      searchUsername: this.props.searchFilter.un,
      filterRole: this.props.searchFilter.uc,
      limit: this.props.searchFilter.lmt,
      offset: this.props.searchFilter.oft,
    });
    this.props.getUserRolesAction(() => {
      //NOSONAR
    });
  }

  componentWillUnmount() {
    if (!this.isUserClick) {
      this.props.setSearchFilterAction(
        SEARCH_FILTER_PAGES.USER_LIST,
        USER_LIST_FILTER
      );
    }
  }

  createRows = (responseData) => {
    //Row create for each element in response data array
    let rows = [];
    let userData = responseData.data.users;
    _.forEach(userData, (userDetails) => {
      let userImage = this.getProfilePic(userDetails.username) || ProfileImage;
      let userRole = userDetails.role.role;
      rows.push({
        image: (
          <img
            className="userAvatar"
            onerror={`this.onerror=null;this.src=${ProfileImage};`}
            src={userImage}
            alt="Avatar"
          />
        ),
        user: userDetails.username,
        firstName: userDetails.firstName,
        lastName: userDetails.lastName,
        role: userRole, //userDetails.role,
        userPreservedData: userDetails,
      });
    });
    this.setState({
      showLoadingModal: false,
      rows,
      numberOfPages: responseData.data.numberOfPages,
    });
  };
  //Get each row
  rowGetter = (i) => {
    return this.state.rows[i];
  };
  //Handle click on row
  callbackOnRowClick = (row) => {
    if (row !== undefined) {
      this.isUserClick = true;
      this.props.saveUserDetailsAction(row.userPreservedData);
      this.props.setSearchFilterAction(
        SEARCH_FILTER_PAGES.USER_LIST,
        this.state.searchFilter,
        SEARCH_FILTER_PAGES.USER_LIST
      );
      this.props.history.push(APPLICATION_CONFIGURATIONS.path.userDetails);
    }
  };
  handleAddUser = () => {
    this.props.clearUserDetailsAction();
    this.props.history.push(APPLICATION_CONFIGURATIONS.path.userDetails);
  };

  //Get all users profile pics
  getAllUserListProfilePic = (usersResponseData) => {
    this.setState({ showLoadingModal: true });
    if (usersResponseData.data.users.length !== 0) {
      let profilePic = [];
      usersResponseData.data.users.map((users) => {
        getProfilePhotoAction(users.username, (responseData, username) => {
          if (responseData.status === API_RESPONSE_STATUS_CODES.SUCCESS) {
            this.createRows(usersResponseData);
            profilePic.push({
              username: users.username,
              image: responseData.data.s3Url,
            });
          } else {
            profilePic.push({
              username: username,
              image: ProfileImage,
            });
          }
          this.setState({
            usersProfilePic: profilePic,
            showLoadingModal: false,
          });
        });
        return null;
      });
    } else {
      this.setState({ rows: [], showLoadingModal: false });
    }
  };

  getProfilePic = (username) => {
    let image = "";
    this.state.usersProfilePic.map((users) => {
      if (users.username === username) {
        image = users.image;
      }
      return null;
    });
    return image;
  };
  handleOnClickSearchFilter = (searchFilterObject) => {
    this.setState({
      showLoadingModal: true,
      searchFilter: {
        un: searchFilterObject.searchUsername,
        uc: searchFilterObject.filterRole,
        oft: searchFilterObject.offset,
        lmt: searchFilterObject.limit,
      },
    });
    getUsersBySearchFilterAction(searchFilterObject, (responseData) => {
      if (responseData.status === API_RESPONSE_STATUS_CODES.SUCCESS) {
        this.createRows(responseData);
      }
      this.getAllUserListProfilePic(responseData);
    });
  };

  render() {
    return (
      <div>
        <LoadingModal showLoadingModal={this.state.showLoadingModal} />
        <UserList
          columns={this._columns}
          rows={this.state.rows}
          rowGetter={this.rowGetter}
          rowsCount={this.state.rows.length}
          onRowClick={this.callbackOnRowClick}
          rowHeight={60}
          userRoles={this.props.userRoles}
          headerRowHeight={40}
          handleAddUser={this.handleAddUser}
          handleOnClickSearchFilter={this.handleOnClickSearchFilter}
          numberOfPages={this.state.numberOfPages}
          searchFilter={this.props.searchFilter}
        />
      </div>
    );
  }
}
function matchDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      getUsersBySearchFilterAction: getUsersBySearchFilterAction,
      saveUserDetailsAction: saveUserDetailsAction,
      clearUserDetailsAction: clearUserDetailsAction,
      getProfilePhotoAction: getProfilePhotoAction,
      getUserRolesAction: getUserRolesAction,
      setSearchFilterAction: setSearchFilterAction,
    },
    dispatch
  );
}
function mapStateToProps(state) {
  return {
    userRoles: state.UserReducer.userRoles,
    searchFilter: state.searchFilterReducer.userListSearchFilter,
  };
}

export default connect(
  mapStateToProps,
  matchDispatchToProps
)(UserListContainer);
